import { getApi } from '../../../shared/api';

export const api = getApi();
